import { useParams } from "@tanstack/react-router";
import { ChatView } from "./ChatView";

/** A single conversation thread (`/chat/$id`). */
export function ChatDetailPage() {
  const { id } = useParams({ strict: false }) as { id?: string };
  return <ChatView conversationId={id ?? null} />;
}
